export default {
  name: 'GestaoDocMixin',
  inject: {
    erplayout: {
      default () {
        console.error('Main needs to be child of ErpLayout')
      }
    }
  },
  mounted() {
    window.setTimeout(() => {
      this.erplayout.erpheader.setMenuModuleToggle(true)
    }, 10)
    document.body.classList.add('docs-body')
    this.erplayout.erpheader.menu.setActiveMenu('gestao')
  },
  destroyed() {
    document.body.classList.remove('docs-body')
  },
  beforeDestroy() {
    this.erplayout.erpheader.setMenuModuleToggle(false)
  }
}
